export enum WarningSubmitNegativeAmountEnum {
  message = 'Amount cannot be less than $0. Please review Manual Preview and make necessary changes.',
};
